import { useAnalytics } from "../hooks/useAnalytics";
import ImpressumModal from "./ImpressumModal";
import { useCallback, useState } from "react";
import styled from "styled-components";

const FooterWrapper = styled.footer`
  padding: 1.75rem 0 2rem;
  text-align: center;
  color: var(--text-secondary);
  border-top: 1px solid var(--border-color);
  margin-top: 3rem;
  background-color: transparent;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.25rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

const FooterLink = styled.a`
  color: var(--text-secondary);
  font-size: 0.85rem;
  transition: color 0.2s;

  &:hover {
    color: var(--accent-color);
  }
`;

const Disclaimer = styled.p`
  font-size: 0.8rem;
  margin-top: 0.75rem;
  line-height: 1.4;
  opacity: 0.7;
`;

const SponsorMessage = styled.div`
  margin-bottom: 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--accent-color);
`;

const ImpressumRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const ImpressumButton = styled.button`
  margin-top: 0.75rem;
  font-size: 0.7rem;
  color: var(--text-secondary);
  opacity: 1;
  text-decoration: underline;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    color: var(--accent-color);
  }
`;

const Footer = () => {
  const [isImpressumOpen, setIsImpressumOpen] = useState(false);
  const { trackContactClick, trackImpressumClick } = useAnalytics();

  const openImpressum = useCallback(() => {
    trackImpressumClick();
    setIsImpressumOpen(true);
  }, [trackImpressumClick]);
  const closeImpressum = useCallback(() => setIsImpressumOpen(false), []);

  const handleContactClick = useCallback(
    (address: string) => {
      trackContactClick(address);
    },
    [trackContactClick],
  );

  return (
    <FooterWrapper>
      <Container>
        <SponsorMessage>Looking for sponsors to keep the Kuack!</SponsorMessage>

        <FooterLinks>
          <FooterLink href="mailto:info@kuack.io" onClick={() => handleContactClick("info@kuack.io")}>
            info@kuack.io
          </FooterLink>
          <FooterLink href="mailto:contact@kuack.io" onClick={() => handleContactClick("contact@kuack.io")}>
            contact@kuack.io
          </FooterLink>
          <FooterLink href="mailto:investors@kuack.io" onClick={() => handleContactClick("investors@kuack.io")}>
            investors@kuack.io
          </FooterLink>
        </FooterLinks>

        <p>&copy; {new Date().getFullYear()} Kuack Project</p>

        <Disclaimer>
          Kuack is currently a Proof of Concept (PoC) and is not ready for production use.
          <br />
          Developed with 🦆 at heart.
        </Disclaimer>

        <ImpressumRow>
          <ImpressumButton type="button" onClick={openImpressum}>
            Impressum
          </ImpressumButton>
        </ImpressumRow>
      </Container>
      {isImpressumOpen && <ImpressumModal onClose={closeImpressum} />}
    </FooterWrapper>
  );
};

export default Footer;
